module.exports = false;


//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 7